module.exports = __webpack_public_path__ + "static/media/book-woman.9d3839c4.svg";